import script from "./BedTypeSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./BedTypeSelector.vue?vue&type=script&setup=true&lang=ts"

import "./BedTypeSelector.vue?vue&type=style&index=0&id=78e44087&scoped=true&lang=css"

import exportComponent from "/builds/intranet/intranet/vue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78e44087"]])

export default __exports__